export default {
  isLoading: false,
  showSidebar: true,
  showOffcanvas: false,
  showItemDetailOffcanvas: false,
  showHelpModal: false,
};
